<template>
  <div class="register-page-left">
    <h1 class="is-size-6 has-text-weight-bold mb10">Create Account</h1>	

            
    <div class="text-left" v-if="screen == 2">
      <p class="is-size-14 mb5">We have sent you a confirmation link to <strong>{{ form.email }}</strong>.</p>
      <p class="is-size-14">You will be good to go as soon as its been verified!</p>
    </div>
         
    <form class="register-page-register-form" ref="registerForm" v-if="screen == 1">
      <div class="social-icons-wrap is-flex is-flex-column">
        <div id="buttonDiv"></div>
        <div class="field mb-5">
          <div class="control">
            <a href="#" class="social-login-signup-wrapper mb10" @click.prevent="signupWithGoogle">
              <div class="social-login-section">
                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 18 18" aria-hidden="true"><title>Google</title><g fill="none" fill-rule="evenodd"><path fill="#4285F4" d="M17.64 9.2045c0-.6381-.0573-1.2518-.1636-1.8409H9v3.4814h4.8436c-.2086 1.125-.8427 2.0782-1.7959 2.7164v2.2581h2.9087c1.7018-1.5668 2.6836-3.874 2.6836-6.615z"></path><path fill="#34A853" d="M9 18c2.43 0 4.4673-.806 5.9564-2.1805l-2.9087-2.2581c-.8059.54-1.8368.859-3.0477.859-2.344 0-4.3282-1.5831-5.036-3.7104H.9574v2.3318C2.4382 15.9832 5.4818 18 9 18z"></path><path fill="#FBBC05" d="M3.964 10.71c-.18-.54-.2822-1.1168-.2822-1.71s.1023-1.17.2823-1.71V4.9582H.9573A8.9965 8.9965 0 0 0 0 9c0 1.4523.3477 2.8268.9573 4.0418L3.964 10.71z"></path><path fill="#EA4335" d="M9 3.5795c1.3214 0 2.5077.4541 3.4405 1.346l2.5813-2.5814C13.4632.8918 11.426 0 9 0 5.4818 0 2.4382 2.0168.9573 4.9582L3.964 7.29C4.6718 5.1627 6.6559 3.5795 9 3.5795z"></path></g></svg>
                <span class="letter-space-0_5 is-size-14">SIGN UP WITH GOOGLE</span>
              </div>
            </a>
          </div>
        </div>
        <div class="field mb0">
          <div class="control">
            <a href="#" class="social-login-signup-wrapper" @click.prevent="signupWithFacebook">
              <div class="social-login-section">
                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24"><path  fill="#4285F4" d="M9 8h-3v4h3v12h5v-12h3.642l.358-4h-4v-1.667c0-.955.192-1.333 1.115-1.333h2.885v-5h-3.808c-3.596 0-5.192 1.583-5.192 4.615v3.385z"/></svg>
                <span class="letter-space-0_5 is-size-14">SIGN UP WITH FACEBOOK</span>
              </div>
            </a>
          </div>
        </div>  
      </div>

      <div class="mt-20 mb-20 is-size-14 has-text-centered"><span class="has-text-dark">Or continue with:</span></div>

      <div class="columns">
        <div class="column is-12-mobile is-12-tablet is-6-widescreen is-6-desktop pb0">
          <div class="field">
            <div class="control">
              <validation-provider name="First Name" ref="first_name" rules="required">
                <template #default="{ errors }">
                  <input
                    class="input"
                    name="First Name"
                    v-model="form.first_name"
                    type="text"
                    placeholder="First Name"
                  />
                  <span class="validation-error">{{ errors[0] }}</span>
                </template>
              </validation-provider>
            </div>
          </div>
        </div>

        <div class="column is-12-mobile is-12-tablet is-6-widescreen is-6-desktop pb0">
          <div class="field">
            <div class="control">
              <validation-provider name="Last Name" ref="last_name" rules="required">
                <template #default="{ errors }">
                  <input
                    class="input"
                    name="Last Name"
                    v-model="form.last_name"
                    type="text"
                    placeholder="Last Name"
                  />
                  <span class="validation-error">{{ errors[0] }}</span>
                </template>
              </validation-provider>
            </div>
          </div>
        </div>
      </div>
  
      <!-- <div class="field">
        <div class="control">
          <validation-provider name="date of birth" ref="date_of_birth" rules="required"> 
            <template #default="{ errors }">
              <vuejs-datepicker v-model="form.dob" :maximum-view="'year'" :typeable="false" :initial-view="'year'" :minimum-view="'day'" full-month-name:="true"  :format="'dd/MM/yyyy'" class="input" id="dob" placeholder="Birthday (dd/mm/yy)"></vuejs-datepicker>
              <span class="validation-error">{{ errors[0] }}</span>
            </template>
          </validation-provider>
          <div class="field mt-5">
            <label class="label is-size-7"><span class="is-required mr10">*</span>Must match government-issued ID.</label>
          </div>
        </div>
      </div> -->

      <!-- <div class="field">
        <div class="control">
          <div class="select is-full-width"> 
            <validation-provider name="Province" ref="province" rules="required">
              <template #default="{ errors }">
                <select v-model="form.province" class="province-select">
                  <option value="" disabled>--Province--</option>
                  <option  v-for="item in vg_province" selected v-bind:key="item.value" :value="item.value">{{ item.name }}</option>
                </select>
                <span class="validation-error">{{ errors[0] }}</span>
              </template>
            </validation-provider>
          </div>
        </div>
      </div> -->

      <div class="field">
        <div class="control has-text-dark" v-if="signupTypeSocial">
         Email: {{ form.email }}
        </div>
        <div class="control" v-show="!signupTypeSocial">
          <validation-provider name="Email" ref="email" rules="required|email"> 
            <template #default="{ errors }">
              <input
                class="input"
                name="Email"
                v-model="form.email"
                type="email"
                placeholder="Email"
              />
              <span class="validation-error">{{ errors[0] }}</span>
            </template>
          </validation-provider>
          <p class="is-size-11 mt5 is-italic">Make sure your email is correct, it has to be verified in order to fully register your account</p>
        </div>
      </div>

      <div class="field">
        <div class="control">
          <validation-provider name="Phone" ref="phone" rules="phone_number_only_if_has_value">
            <template #default="{ errors }">
              <input
                class="input hide-arrow"
                name="Phone"
                v-model="form.phone"
                type="number"
                onkeydown="if(event.key==='.'){event.preventDefault();}"
                placeholder="Phone Number"
              />
              <span class="validation-error">{{ errors[0] }}</span>
            </template>
          </validation-provider>
        </div>
      </div>

      <!-- <div class="field">
        <div class="control">
          <ValidationProvider ref="password" name="Password" rules="required|verify_password|min:8" v-slot="{ errors }" vid="password">
            <input 
              v-model="form.password" 
              class="input" 
              type="password" 
              placeholder="Password">
            <span class="validation-error" v-if="errors[0] " v-html="errors[0] "></span>
          </ValidationProvider>   
        </div>
      </div> -->

      <!-- <div class="field">
        <div class="control">
          <ValidationProvider name="Confirm Password" ref="confirm_password" rules="required|confirmed:password" v-slot="{ errors }">
            <input 
              v-model="form.confirm_password" 
              class="input" 
              type="password" 
              placeholder="Confirm Password">
            <span class="validation-error">{{ errors[0] }}</span>
          </ValidationProvider>
        </div>
      </div>   -->

      <div class="field register-page-policies-list">
        <p class="has-text-weight-semibold mb10">Security policies according to your province law</p>
        <ul>
          <!-- <li>You must be {{ getProvinceAge(form.province) ? getProvinceAge(form.province) : '19' }} years of age or older.</li> -->
          <li>The information on your ID and the information on your account must match.</li> 
          <li>To retrieve your order, you will need to show a valid government-issued photo ID.</li>
        </ul>
        <div class="mt20 mb10 checkout-offers">
          <input class="is-checkradio" v-model="form.marketing_notification" id="signupOptIn" type="checkbox" name="signupOptIn" :value="1">
          <label for="signupOptIn" class="has-text-black is-size-6">Sign up for new offers and discounts</label>
        </div>
        <button class="button is-large bg-secondary text-white hover-opacity-7 is-full-width mt20" @click.prevent="signUp()">SIGN UP</button>
        <div class="has-text-centered is-size-13 mt20 mb30 has-text-black">
          By clicking signing up, you agree to Budler <router-link :to="{ name: 'TermsConditions', params: { business_slug: $route.params.business_slug }, query: $route.query}">Terms & Conditions</router-link> 
           and <router-link target="_blank" :to="{ name: 'PrivacyPolicy',  params: { business_slug: $route.params.business_slug }, query: $route.query }" class="has-underline ">Privacy Policy</router-link>
        </div>
      </div>
    </form>

  </div>
             
</template>
<script>
import Env from '@/env';
import { mapGetters, mapActions } from 'vuex';
import vuejsDatepicker from 'vuejs-datepicker';
import moment from 'moment';
import Helpers from '@/Components/Helpers/Helpers';
import SignupApis from '@/Components/Controllers/SignupApis';
import VboutApis from '@/Components/Controllers/VboutApis';
import UserApis from '@/Components/Controllers/UserApis';

export default {
  components: {
    vuejsDatepicker,
  },
  name: 'RegisterPageregister',
  data() {
    return {
      // Register
      signupTypeSocial: false,
      screen: 1, 
      form: {
        first_name: '',
        last_name: '',
        email: '',
        phone: '',
        social_type: '',
        social_id: '',
        marketing_notification: false,
        redirect_url: '',
        // Need to add 
        business_id: '',
        business_name: '',
        business_slug: '',
        logo_url: '',
      },
    };
  },
  computed: {
    ...mapGetters({
      vg_modal: 'signupmodal/modal',
      vg_visitorDetail: 'getVisitorDetails',
      vg_selectedStore: "location/selected", 
      vg_userId: "getLoggedInUserId",
      vg_businessProfile: "businessprofile/detail", 
      vg_businessLoyality: "businessprofile/businessLoyality",
      vg_cartItems: "cart/cartItems",
    }),

    vg_province() {
      return Env.provinces;
    },
  },
  
  watch: {
    form: {
      handler: function () {
        if(this.form.social_type && this.form.social_id){
          this.signupTypeSocial = true;
        } else {
          this.signupTypeSocial = false;
        }
      },
      deep: true
    },
    'form.phone'(val) {
       if(val.indexOf(".") != -1) {
        this.form.phone = val.replace(/\./g,"");
      }
      let newval = val.trim();
      if(val.length > 10){
        newval = newval.slice(0,10)
      } 
      this.form.phone = newval;
    },

    'form.email'(val) {
      this.form.email = val.replaceAll(/\s/g,'').toLowerCase().trim();
    },
   
  },

  mounted() {

  },

  methods: {
    /**
     * Signup with google
     */
    signupWithGoogle() {
      const self = this;
      this.$gAuth
        .signIn()
        .then( async (GoogleUser) => {
          let googleProfile = GoogleUser.getBasicProfile();
          self.form.first_name = googleProfile.getGivenName();
          self.form.last_name = googleProfile.getFamilyName();
          self.form.email = googleProfile.getEmail();
          self.form.social_type = 'google';
          self.form.social_id = GoogleUser.getId();
        })
        .catch(error => {
          console.log('error', error)
        })
    },

     /**
     * Signup with facebook
     */
    signupWithFacebook() {
      const self = this;
      //self.va_spinner(true);
      window.FB.login(async function(response) {
        if (response.authResponse) {
          await window.FB.api('/me', { 
            locale: 'en_US', 
            fields: 'id,first_name,last_name,email,link,gender,locale' 
          }, function(fbData){
            self.va_spinner(false);
            if (fbData.id) {
              self.form.first_name = fbData.first_name;
              self.form.last_name = fbData.last_name;
              self.form.email = fbData.email;
              self.form.social_type = 'facebook';
              self.form.social_id = response.authResponse.userID;
            } else {
              self.va_snackbar({
                type: 'warning',
                message: 'Unable to fetch facebook detail.',
              });
            }
          });      
        } else {
          self.va_spinner(false);
          self.va_snackbar({
            type: 'warning',
            message: 'User cancelled login or did not fully authorize.',
          });
        }
      }, { 
        scope: 'public_profile,email'
      });
      return false;
    },

     /**
     * Register
     */
    async signUp() {

      let validation = await Helpers.validateRefs(this, ['first_name', 'last_name', 'email', 'phone']);
      if( validation ) {
        // If found any location selected pass to that lcoation
        let redirectUrl; 
        // when signup from here , check if any location default selected then pass to that location shop, else to business page
        // fry to redirect to first lcoation becasue first is by default selected
        if( !_.isEmpty(this.vg_selectedStore) ){
          redirectUrl = this.$router.resolve({ 
            name: 'StoreProfile',
            params: { 
              business_slug: this.$route.params.business_slug,
              store_slug: this.vg_selectedStore.slug
            },
          });
        } else {
          redirectUrl = this.$router.resolve({ 
            name: 'HomePage',
            params: { 
              business_slug: this.$route.params.business_slug,
            },
          });
        }
        // let signUpredirectPage = this.$router.resolve({ 
        //   name: 'SignUpAuthenticate',
        //   params: { 
        //      business_slug: this.$route.params.business_slug
        //   },
        // });
        // this.form.redirect_url = window.location.protocol + '//' + window.location.host + signUpredirectPage.href;

        this.form.redirect_url =  window.location.protocol + '//' + window.location.host + redirectUrl.href;
        this.va_spinner(true);
        let obj = _.clone(this.form);
        if(!this.signupTypeSocial){
          delete obj['social_type'];
          delete obj['social_id'];
        }

         // Need to Add
        obj.business_id = this.vg_businessProfile.id;
        obj.business_name = this.vg_businessProfile.name;
        obj.business_slug = this.$route.params.business_slug;
        obj.logo_url = (this.vg_businessProfile && this.vg_businessProfile.branding && this.vg_businessProfile.branding.logo_url) ? this.vg_businessProfile.branding.logo_url : '';
        // obj.location_id = '';
        // obj.location_slug = '';

        // sign hits loyality user auto
        let res = await SignupApis.passwordLessSignup(obj);

        if(res.status == 201){
          // Push user to vbout
          let vboutAddUser = await VboutApis.upsertUser(res.data.payload, this.vg_selectedStore.id);
          // If user has marketing_notification pass on vbout
          if(vboutAddUser.status == 201){
            const promise1 = res.data.payload.marketing_notification ? VboutApis.addUserTag({
                email: res.data.payload.email,
                tagname: 'casl_opt_in',
              }, this.vg_selectedStore.id) : false;
            
            const promise2 = res.data.payload.email_verification_status ? VboutApis.addUserTag({
                email: res.data.payload.email,
                tagname: 'verified',
              }, this.vg_selectedStore.id) : false;

            // trigger once to save time 
            await Promise.all([promise1, promise2]).then((values) => {
              // Dont need result just need to trigger
            });
          }
         
          this.$refs.registerForm.reset();
          // Now user dont need to verify age
          this.$store.dispatch('SET_VISITOR_DETAILS', {
            ageVerify: true,
            dob: '',
            province: '',
            remember: false,
          });   

          // If user is social register we need to log the user in
          if(this.signupTypeSocial){
            await this.setLoginSuccessUserData(res);
            this.va_spinner(false);
            // After logged in throw them to homepage
            this.$router.push({
              name: 'HomePage',
              params: {
                business_slug: this.$route.params.business_slug
              },
              query: this.$route.query,
            })
          } else {
            window.scrollTo({
              top: 0,
              left: 0,
              behavior: 'smooth'
            });
            // If not social login throw them a message
            this.screen = 2;
          }
          this.va_spinner(false);
     
        } else {
          this.va_spinner(false);
          this.va_snackbar({
            type: res.status == 201 ? 'success' : 'warning',
            message: res.status == 201 ? res.data.msg : res.response.data.msg,
          });
        }

      } 
    },


    /**
     * on success login set datas
     */
    async setLoginSuccessUserData(res) {
      const self = this;
      // Add user location on login
      if(this.vg_selectedStore.id){
        UserApis.addUserLocation(res.data.payload.id, this.vg_selectedStore.id, this.$route.query);
      }
      this.$store.dispatch("SET_USER_TOKEN", res.data.payload.token);
      this.$store.dispatch("SET_USER_DETAILS", res.data.payload);
      this.$store.dispatch("SET_USER_LOGGEDIN_DATE", moment().format('YYYY-MM-DD HH:mm:ss'));

      // Start loyalty stuffs only if business is active
      if(this.vg_businessLoyality.id && this.vg_businessLoyality.is_active) {

        // If not setup try it, signup hits loyality in it
        let loyaltyJoinRes = await this.va_joinUserOnLoyalityProgram({
          user_id: res.data.payload.id,
          business_id: this.vg_businessProfile.id
        })

        // Signup but as signin
        if( (loyaltyJoinRes.status == 201) && (loyaltyJoinRes.data.payload.welcome_bonus > 0) ) {
          // show loyalty bonus point for signup
          bus.$emit('loyality-signup-congratulations', {
            modal: true,
            point: loyaltyJoinRes.data.payload.welcome_bonus,
            message: "Sign Up Bonus!",
          })
        }

        // Show loyalty referral point
        if( (loyaltyJoinRes.status == 201) && (loyaltyJoinRes.data.payload.referral_bonus > 0) ) {
          bus.$emit('loyality-referral-congratulations', {
            modal: true,
            point: loyaltyJoinRes.data.payload.referral_bonus,
            message: "A little something for being referred!",
          })
        }
      }

    },

    // /**
    //  * Get province age limit
    //  */
    // getProvinceAge(code) {
    //   if(!code){
    //     return '';
    //   }
    //   let provinceObj = _.find(this.vg_province, { value: code });
    //   if(provinceObj){
    //     return provinceObj.age;
    //   }
    //   return '';
    // },

    ...mapActions({
      va_snackbar: "snackbar/setSnackbar",
      va_spinner: "spinner/setSpinner",
      va_joinUserOnLoyalityProgram: "userloyalitysubscription/joinUserOnLoyalityProgram",
    }),
  },
};
</script>